// Libraries
import ScrollOut from "scroll-out";

// Ultils
import { pageListener } from "./utils";
import LazyLoadImage from "./lazy-load";
import Common from "./_Common";
import Home from "./_Home";
import News from "./_News";
import Contact from "./_Contact";
import ContactGoogleMaps from "./_ContactGoogleMaps"; // NEW: Google Maps implementation
import Awards from "./_Awards";
import About from "./_About";
import BookingForm from "./_BookingForm";
import Specialty from "./_Specialty";
import Doctors from "./_Doctors";
import Hospital from "./_Hospital";
import Packages from "./_Packages";
import CookieConsent from "./CookieConsent";

export default class Main {
  constructor() {
    this.PageSetup();
    this.initUTMTracking();

    // Behavior For Each Pages
    let common = new Common();
    let home = new Home();
    let bookingForm = new BookingForm();
    let news = new News();
    let contact = new Contact(); // Contact form only (map disabled)
    let contactGoogleMaps = new ContactGoogleMaps(); // NEW: Google Maps for hospital map
    let awards = new Awards();
    let about = new About();
    let specialty = new Specialty();
    let doctors = new Doctors();
    let hospital = new Hospital();
    let packages = new Packages();
    
    // Initialize Cookie Consent Manager
    let cookieConsent = new CookieConsent();
  }

  PageSetup() {
    // Run Lazy Load Image Function First
    const lazyLoadImage = new LazyLoadImage();

    // Ipad devices and below
    window.IS_MOBILE = window.innerWidth > 820 ? false : true;

    // Better approach: Prevent reload on mobile address bar hide/show
    let timeoutId;
    $(window).on("resize", () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        let wasMobile = window.IS_MOBILE;
        let newIsMobile = window.innerWidth > 820 ? false : true;

        window.IS_MOBILE = newIsMobile;

        // Disabled: Mobile reload causes issues with address bar hide/show
        // if (wasMobile !== newIsMobile) {
        //   window.location.reload();
        // }
      }, 150); // Debounce to prevent rapid fire on mobile scroll
    });
  }

  initUTMTracking() {
    // Kiểm tra nếu có UTM trong URL
    const urlParams = new URLSearchParams(window.location.search);
    const utmParams = {};
    let hasUTM = false;

    // Các tham số UTM
    const utmKeys = [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_term",
      "utm_content",
      "utm_adgroup",
      "utm_ad",
    ];

    // Check nếu có bất kỳ tham số UTM nào
    utmKeys.forEach((key) => {
      if (urlParams.has(key)) {
        utmParams[key] = urlParams.get(key);
      }
    });

    // bật flag nếu có bất kỳ tham số UTM
    hasUTM = Object.keys(utmParams).length > 0;

    // Nếu không có UTM, return luôn
    if (!hasUTM) return;

    const newUtmData = {
      ...utmParams,
      timestamp: Date.now(),
      url: window.location.href,
    };

    const existingData = this.getUTMData();
    if (!existingData) {
      // Nếu ko có sẵn UTM, lưu dữ liệu mới vào localStorage
      localStorage.setItem("hm_utm_data", JSON.stringify(newUtmData));
    } else {
      // Nếu đã có sẵn UTM, so sánh và thay thế nếu khác
      const existingUtmParams = { ...existingData };
      delete existingUtmParams.timestamp;
      delete existingUtmParams.url;
      const isSameData =
        JSON.stringify(existingUtmParams) === JSON.stringify(utmParams);
      if (!isSameData) {
        localStorage.setItem("hm_utm_data", JSON.stringify(newUtmData));
      }
    }
  }

  getUTMData() {
    try {
      const storedData = localStorage.getItem("hm_utm_data");
      if (!storedData) {
        return null;
      }

      const utmData = JSON.parse(storedData);

      // Check valid data (7 days)
      const now = Date.now();
      const validRange = 7 * 24 * 60 * 60 * 1000; // 7 days (ms)
      const ageInMs = now - utmData.timestamp;

      if (ageInMs <= validRange) {
        return utmData;
      } else {
        // Data expired, remove it
        localStorage.removeItem("hm_utm_data");
        return null;
      }
    } catch (error) {
      console.warn("Error getting UTM data:", error);
      return null;
    }
  }
}

// Auto-initialize
new Main();
